var divider_viewer_rtlignore_default = {
  "divider-container": "hSIW6",
  "divider-container--double": "BNIN9",
  "divider": "oA9BR",
  "divider--single": "-JMGG",
  "divider--double": "KhCw9",
  "divider--dashed": "xdhuk",
  "divider--dotted": "c1TqV",
  "divider--small": "a7ey4",
  "divider--medium": "RBtSy",
  "divider--large": "YItJR",
  "divider--left": "shMsA",
  "divider--center": "pR021",
  "divider--right": "kI1Ue",
  "svgFixerContainer": "-K7wg",
  "emptyChar": "oyz1G"
};
export {
  divider_viewer_rtlignore_default as default
};
//# sourceMappingURL=divider-viewer.rtlignore-scss.js.map
